export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_447762f6-2a8c-46c6-ba95-f07db1df3eb0/artifacts/sfaht9y4_Equinoxe_Studio_blanc-resize.png";

export const CONTACT = {
  phone: "05 32 18 90 44",
  phoneRaw: "+33532189044",
  whatsapp: "+33532189044",
  hours: "Support téléphonique · du lundi au samedi, 7h – 22h",
  whatsappHours: "WhatsApp · 24h/24, 7j/7",
  city: "Cazals",
  postal: "46250",
  group: "Groupe Equinoxe",
  groupUrl: "https://groupeequinoxe.fr/",
};

export const SERVICES = [
  {
    slug: "audit-conseil-strategie",
    index: "01",
    title: "Audit, conseil et stratégie",
    tagline: "Comprendre avant d'agir",
    description:
      "Nous analysons votre marché, votre image et vos objectifs pour construire une stratégie de communication claire et efficace. Un diagnostic précis, des recommandations concrètes et une feuille de route adaptée à votre activité.",
    points: ["Audit de communication & image", "Analyse concurrentielle", "Stratégie de marque", "Feuille de route & accompagnement"],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_equinoxe-lot/artifacts/39bbbbf9d91efb4e_1%20-%20Strat%C3%A9gie%20analytique%20au%20bureau.png",
  },
  {
    slug: "design-branding",
    index: "02",
    title: "Design et branding",
    tagline: "Identité visuelle & supports",
    description:
      "Nous façonnons des identités de marque mémorables : logos, chartes graphiques, supports print et signalétique. Chaque détail est pensé pour incarner votre entreprise et marquer les esprits.",
    points: ["Logo & identité visuelle", "Chartes graphiques", "Supports print & papeterie", "Marquage & signalétique"],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_equinoxe-lot/artifacts/f3feeb2800eb7dcd_2%20-%20Studio%20cr%C3%A9atif%20aux%20accents%20violets.png",
  },
  {
    slug: "developpement-web",
    index: "03",
    title: "Développement web",
    tagline: "Sites & plateformes sur-mesure",
    description:
      "De la vitrine élégante à la plateforme e-commerce, nous développons des sites rapides, responsives et taillés pour convertir. Technologies modernes, code propre, résultats concrets.",
    points: ["Sites vitrines", "E-commerce", "Applications & plateformes", "Référencement & performance"],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_equinoxe-lot/artifacts/22447b55df3028a4_3%20-%20Cr%C3%A9ateur%20num%C3%A9rique%20dans%20un%20studio%20violet.png",
  },
  {
    slug: "productions-photos-videos",
    index: "04",
    title: "Productions photos et vidéos",
    tagline: "Des images qui racontent",
    description:
      "Films de marque, captations, reportages et photographie professionnelle. Nous mettons en valeur votre activité, vos produits et vos évènements, avec une exigence de qualité du concept au montage final.",
    points: ["Films de marque & corporate", "Captation & reportage", "Photographie professionnelle", "Montage & post-production"],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_equinoxe-lot/artifacts/3555d91fedeed325_4%20-%20Photographe%20au%20studio%20baign%C3%A9%20de%20n%C3%A9ons%20violets.png",
  },
  {
    slug: "reseaux-sociaux",
    index: "05",
    title: "Gestion des réseaux sociaux",
    tagline: "Présence & communauté",
    description:
      "Nous animons vos réseaux sociaux : ligne éditoriale, création de contenus, publication et engagement. Une présence régulière et cohérente pour développer votre visibilité et fédérer votre communauté.",
    points: ["Ligne éditoriale & calendrier", "Création de contenus", "Community management", "Reporting & performance"],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_equinoxe-lot/artifacts/503fc0f792c47cce_5%20-%20Studio%20cr%C3%A9atif%20aux%20accents%20violets.png",
  },
];

export const CATEGORIES = [
  { key: "all", label: "Tout" },
  { key: "web", label: "Sites web" },
  { key: "print", label: "Design papier" },
  { key: "vehicle", label: "Marquage véhicule" },
];

export const CATEGORY_LABELS = {
  web: "Site web",
  print: "Design papier",
  vehicle: "Marquage véhicule",
};
